import type * as Types from '@formic/fusion-graphql/schema';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProjectScreenOptionsFragment = { displayProjectsOnHomeScreen: boolean };

export type HomeScreenProjectsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HomeScreenProjectsQuery = { projects: Array<{ id: number, name: string, goals?: Types.Maybe<string>, currentCompletionCount?: Types.Maybe<number>, maxCompletionCount?: Types.Maybe<number>, currentMaxUserCompletionCount?: Types.Maybe<number>, maxUserCompletionCount?: Types.Maybe<number>, onlineOptions: { isVisibleInContents: boolean }, onlinePermissions: { userSubmissionCountRestricted: boolean }, projectTranslations: Array<{ projectName: string, subTag: string, nativeLanguage: string }> }> };

export const ProjectScreenOptionsFragmentDoc = /*#__PURE__*/ gql`
    fragment ProjectScreenOptions on GlobalOnlineFormsOptions {
  displayProjectsOnHomeScreen
}
    `;
export const HomeScreenProjectsDocument = /*#__PURE__*/ gql`
    query homeScreenProjects {
  projects {
    id
    name
    goals
    currentCompletionCount
    maxCompletionCount
    currentMaxUserCompletionCount
    maxUserCompletionCount
    onlineOptions {
      isVisibleInContents
    }
    onlinePermissions {
      userSubmissionCountRestricted
    }
    projectTranslations {
      projectName
      subTag
      nativeLanguage
    }
  }
}
    `;

export function useHomeScreenProjectsQuery(options: Omit<Urql.UseQueryArgs<HomeScreenProjectsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HomeScreenProjectsQuery>({ query: HomeScreenProjectsDocument, ...options });
};